export const SET_WORKERS_LIST = "SET_WORKERS_LIST";
export const SET_WORKERS_LIST_LOAD = "SET_WORKERS_LIST_LOAD";
export const SET_WORKERS_LIST_ERROR = "SET_WORKERS_LIST_ERROR";

export const SET_WORKER_SELECTED = "SET_WORKER_SELECTED";
